import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Table,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAllPassports,
  getPassportById,
  updatePassport,
  resetPassportDetails,
  resetPassportUpdate,
  resetPassportList,
} from "../features/passport/passportSlice";
import {
  createDueCollection,
  getAllDueCollections,
  getDueCollectionById,
  updateDueCollection,
  deleteDueCollection,
  getDueCollectionsByPassportId,
  resetDueCollectionCreate,
  resetDueCollectionList,
  resetDueCollectionDetails,
  resetDueCollectionDelete,
  resetDueCollectionUpdate,
} from "../features/duecollection/duecollectionSlice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

import Loader from "../components/Loader";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { TiPrinter } from "react-icons/ti";
import DueCollectionPrint from "../components/DueCollectionPrint";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: "38",
  },
  section: {
    // margin: 20,
    // padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#3c8dbc",
    textAlign: "center",
    marginBottom: 10,
    fontFamily: "Helvetica-Bold",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // bottom: -100,
    // width: "20%",
    // position: "absolute",
  },
  signatureLeft: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "center",
    fontFamily: "Helvetica",
    justifyContent: "flex-start",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  signatureRight: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "right",
    fontFamily: "Helvetica",
    justifyContent: "flex-end",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  line: {
    border: "1px dashed black",
    borderRadius: "1px",
    width: "150%",
  },
  // header: {
  //   fontSize: 25,
  //   fontWeight: "bold",
  //   textAlign: "center",
  //   margin: 20,
  // },
  address: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 10,
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  table: {
    // display: "table",
    // width: "100%",
    // borderStyle: "dotted",
    // borderWidth: 1,
    // borderCollapse: "collapse",
    // borderBottom: 1,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    borderStyle: "dotted",
  },
  tableRow2: {
    flexDirection: "row",
    borderStyle: "dotted",
  },
  tableCell: {
    width: "33.33%",
    // minWidth: 150,
    height: 25,
    // display: "flex",
    // flex: 1,
    // flexDirection: "column",
    // justifyContent: "space-between",
    fontSize: "10",
    textAlign: "center",

    // overflow: "visible",
    
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
    fontFamily: "Helvetica-Bold",
  },
  tableData: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
  },
  header: {
    fontSize: 12,
    textAlign: "center",
    margin: "20",
    fontFamily: "Helvetica-Bold",
  },

  agentName: {
    // displayL: "table",
    widtxh: "auto",
    fontSize: 15,
    fontWeight: "bold",
    textAlign: "left",
    borderStyle: "dotted",
    borderWidth: 1,
    borderCollapse: "collapse",
    paddingLeft: 20,
    marginBottom: 20,
  },
  commonInfo: {
    fontSize: 10,
    fontWeight: 600,
    textAlign: "left",
    borderStyle: "dotted",
    borderWidth: 1,
    borderCollapse: "collapse",
    paddingLeft: 15,
    paddingBottom: 5,
    paddingTop: 5,
    marginBottom: 20,
    // padding: 20,
    // "@media max-width: 400": {
    //   flexDirection: "column",
    // },
  },
  content: {
    padding: 20,
    "@media max-width: 400": {
      flexDirection: "column",
    },
  },
  Bottom: {
    fontSize: 10,
    textAlign: "center",
    marginTop: 20,
  },
});

const UpdateDueCollection1 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  // const componentRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  // });

  const { userInfo } = useSelector((state) => state.user);
  const {
    passport,
    passports,

    isDetailsLoading,
    isDetailsError,
    detailsErrorMessage,
    isDetailsSuccess,

    isUpdateLoading,
    isUpdateError,
    updateErrorMessage,
    isUpdateSuccess,
  } = useSelector((state) => state.passport);

  const {
    duecollection,
    duecollections,

    isCreateLoading,
    isCreateError,
    createErrorMessage,
    isCreateSuccess,

    isListLoading,
    isListError,
    listErrorMessage,
    isListSuccess,

    isListByPassportIdLoading,
    isListByPassportIdError,
    listByPassportIdErrorMessage,
    isListByPassportIdSuccess,

    isDetailsLoading: isDueCollectionDetailsLoading,
    isDetailsError: isDueCollectionDetailsError,
    detailsErrorMessage: dueCollectionDetailsErrorMessage,
    isDetailsSuccess: isDueCollectionDetailsSuccess,

    isUpdateLoading: isDueCollectionUpdateLoading,
    isUpdateError: isDueCollectionUpdateError,
    updateErrorMessage: dueCollectionUpdateErrorMessage,
    isUpdateSuccess: isDueCollectionUpdateSuccess,

    isDeleteLoading,
    isDeleteError,
    deleteErrorMessage,
    isDeleteSuccess,
  } = useSelector((state) => state.duecollection);

  const [contractAmount, setContractAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [payNow, setPayNow] = useState(0);
  const [dueAmount, setDueAmount] = useState(contractAmount - paidAmount);
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [agentName, setAgentName] = useState("");
  const [fullName, setFullName] = useState("");

  const [dueCollections, setDueCollections] = useState([]);

  const [paymentError, setPaymentError] = useState("");

  const [paymentRecords, setPaymentRecords] = useState([]);
  const [passportContracts, setPassportContracts] = useState([]);

  // const [preview, setPreview] = useState(false);
  const [printPreview, setPrintPreview] = useState(false);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
  }, [userInfo, navigate]);

  // List of due collection
  useEffect(() => {
    if (isListByPassportIdError) {
      toast.error(listByPassportIdErrorMessage, { position: "top-center" });
    } else if (isListByPassportIdSuccess) {
      setDueCollections(duecollections);
    } else dispatch(getDueCollectionsByPassportId(params.id));
  }, [isListByPassportIdError, isListByPassportIdSuccess]);

  // Create due collection
  useEffect(() => {
    if (isCreateError) {
      // toast.error(createErrorMessage, { position: "top-center" });
    } else if (isCreateSuccess) {
      toast.success("Due Collection Created Successfully", {
        position: "top-center",
      });
      dispatch(getDueCollectionsByPassportId(params.id));
    }
  }, [isCreateError, createErrorMessage, isCreateSuccess]);

  // Due collection details
  useEffect(() => {
    if (isDueCollectionDetailsError) {
      toast.error(dueCollectionDetailsErrorMessage, { position: "top-center" });
    } else if (isDueCollectionDetailsSuccess) {
      setDueCollections(duecollection);
    } else {
      dispatch(getDueCollectionsByPassportId(params.id));
    }
  }, [
    isDueCollectionDetailsError,
    isDueCollectionDetailsSuccess,
    dueCollectionDetailsErrorMessage,
  ]);

  // Details from Passport
  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setContractAmount(passport.contractAmount);
      setPaidAmount(passport.paidAmount);
      setDueAmount(passport.dueAmount);
      setPaymentDate(passport.paymentDate);
      setPaymentStatus(passport.paymentStatus);
      setAgentName(passport.agent);
      setFullName(passport.fullName);
    } else {
      dispatch(getPassportById(params.id));
    }
  }, [isDetailsError, isDetailsSuccess, detailsErrorMessage]);

  // Update from passport
  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Passport Payment Updated Successfully", {
        position: "top-center",
      });
      dispatch(getPassportById(params.id));
      // navigate("/dueCollectionList");
    }
  }, [isUpdateError, updateErrorMessage, isUpdateSuccess]);

  useEffect(() => {
    return () => {
      dispatch(resetPassportDetails());
      dispatch(resetPassportUpdate());
    };
  }, [dispatch]);

  const payCheck = (v) => {
    if (v * 1 > contractAmount * 1 || v * 1 < 0) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Due Collection Deleted Successfully", {
        position: "top-center",
      });
      // dispatch(resetDueCollectionDelete());
      // dispatch(getAllDueCollections());
    }
  }, [isDeleteError, isDeleteSuccess, deleteErrorMessage]);

  const handleAddDueRecord = () => {
    // Calculate the new due amount
    // const totalPaidAmount = passport.paidAmount + paidAmount;

    if (payCheck(paidAmount) === false) {
      toast.error("Paid amount cannot be greater than contract amount", {
        position: "top-center",
      });
      return;
    }

    const newPaidAmount = paidAmount * 1 + payNow * 1;

    const newDueAmount = contractAmount * 1 - newPaidAmount * 1;

    // const paymentDate = moment().format("YYYY-MM-DD");
    // const paymentDate = new Date().moment().format("YYYY-MM-DD");
    // const paymentDate = new Date().toLocaleDateString().split("/").reverse().join("-");

    // newPaymentStatus will be "Paid" if the newDueAmount is 0, otherwise it will be "Due"
    const newPaymentStatus = newDueAmount === 0 ? "Paid" : "Due";
    // const newPaymentStatus = newDueAmount === 0 ? "Paid" : "Due";

    // Create a new due collection object
    const newDueCollection = {
      dueCollectionDate: paymentDate,
      dueCollectionAmount: payNow,
      dueCollectionFor: params.id,
    };

    // Dispatch the createDueCollection action to add the new due collection
    dispatch(createDueCollection(newDueCollection));

    // Update the passport information
    const updatedPassport = {
      passportScanCopy: passport.passportScanCopy,
      fullName: passport.fullName,
      passportNumber: passport.passportNumber,
      phone: passport.phone,
      email: passport.email,
      address: passport.address,
      dateOfBirth: passport.dateOfBirth,
      age: passport.age,
      doIssueDate: passport.doIssueDate,
      passportReceiveDate: passport.passportReceiveDate,
      country: passport.country,
      company: passport.company,
      clientPost: passport.clientPost,
      agent: passport.agent,
      officeAgent: passport.officeAgent,
      initialContract: passport.initialContract,
      discount: passport.discount,
      contractAmount: contractAmount,
      paidAmount: newPaidAmount,
      dueAmount: newDueAmount,
      deliveryOffice: passport.deliveryOffice,
      deliveryOfficePayment: passport.deliveryOfficePayment,
      status: passport.status,
      paymentStatus: newPaymentStatus,
    };

    // console.log(updatedPassport);

    // Dispatch the updatePassport action to update the passport information
    dispatch(updatePassport({ id: params.id, passportData: updatedPassport }));
    setPayNow(0);
    setPaymentStatus(newPaymentStatus);
    // setContractAmount(0);
    // setPaidAmount(0);
    // setDueAmount(0);
    // setPaymentDate("");
    // setPaymentStatus("N/A");
  };

  useEffect(() => {
    return () => {
      dispatch(resetDueCollectionCreate());
      dispatch(resetDueCollectionList());
      dispatch(resetDueCollectionDelete());
    };
  }, []);

  // Update the payment status everytime the paid amount or contract amount changes
  useEffect(() => {
    setDueAmount(contractAmount * 1 - paidAmount * 1);
    setPaymentStatus(dueAmount === 0 ? "Paid" : "Due");
  }, [contractAmount, paidAmount, dueAmount]);

  const handleDeleteDueRecord = (id) => {
    if (
      window.confirm("Are you sure you want to delete this expense record?")
    ) {
      dispatch(deleteDueCollection(id));
      // dispatch(resetDueCollectionDelete());
      dispatch(resetDueCollectionList());
    }
  };

  const totalPaid = dueCollections.reduce(
    (total, curr) => total + curr.dueCollectionAmount,
    0
  );

  // alert(totalPaid);

  return (
    <>
      {printPreview ? (
        <>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document>
              <Page size="A4" style={styles.page} orientation="landscape">
                <View style={styles.section}>
                  <Text style={styles.title}>Northeast Overseas LTD.</Text>
                  <Text style={styles.address}>
                    Gulfesha Plaza, 12/0, 69 Outer Circular Road, Boro Mogbazar,
                    Dhaka-1217
                  </Text>
                  <Text style={styles.address}>
                    Phone: +880241031411-2 || Email: info@northeastoverseas.com
                  </Text>
                  <Text style={styles.header}>DUE COLLECTION RECORDS</Text>

                  <Text style={styles.commonInfo}>
                    <Text style={{ fontFamily: "Helvetica-Bold" }}>
                      Passenger Name :{" "}
                    </Text>{" "}
                    {passport?.fullName}
                    {"\n"} {"\n"}
                    <Text style={{ fontFamily: "Helvetica-Bold" }}>
                      Country :{" "}
                    </Text>{" "}
                    {passport?.country}
                    {"\n"} {"\n"}
                    <Text style={{ fontFamily: "Helvetica-Bold" }}>
                      Agent Name :{" "}
                    </Text>
                    {passport?.agent}
                  </Text>

                  <View style={styles.tableContainer}>
                    <View style={styles.table}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCell}>
                          <Text>SL</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Initial Contract</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Discount</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Contract Amount</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Paid Amount</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Due Amount</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Payment Date</Text>
                        </View>
                      </View>

                      {dueCollections.map((dueCollection, index) => (
                        <View style={styles.tableRow} key={index}>
                          <View style={styles.tableData}>
                            <Text>{index + 1}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.initialContract}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.discount}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.contractAmount}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{dueCollection.dueCollectionAmount}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>
                              {passport.contractAmount -
                                dueCollections
                                  .slice(0, index + 1)
                                  .reduce(
                                    (total, curr) =>
                                      total + curr.dueCollectionAmount,
                                    0
                                  )}
                            </Text>
                          </View>
                          <View style={styles.tableData}>
                            {/* Date should be filtered as DD/MM/YYYY */}
                            <Text>
                              {moment(dueCollection.createdAt).format(
                                "DD-MMM-YYYY"
                              )}
                            </Text>
                            {/* <Text>{dueCollection.createdAt}</Text> */}
                          </View>
                        </View>
                      ))}

                      <View style={styles.tableRow2}>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Total Paid : {totalPaid}</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Total Due : {dueAmount}</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                      </View>
                    </View>
                  </View>

                  {/* Signature Section */}
                  <View style={styles.footer}>
                    <View style={styles.row}>
                      <View style={styles.signatureLeft}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Agent Signature
                        </Text>
                      </View>

                      <View style={styles.signatureRight}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Authorized Signature
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
          <Button variant="danger" onClick={() => setPrintPreview(false)}>
            Cancel
          </Button>
        </>
      ) : (
        <Container fluid className="my-4">
          <>
            <Row className="">
              <Card
                className="rounded-4 border"
                style={{ backgroundColor: "#e6edf1" }}
              >
                <h2 className="my-3 text-dark text-center fw-bold">
                  Due <span style={{ color: "#5c91dc" }}>Collection</span>{" "}
                  Records
                </h2>
              </Card>
            </Row>
            {/* <h2 style={{ fontWeight: "bold " }} className="mb-4 text-center">
              Due Collection Records
            </h2> */}

            <Row className="my-4">
              <Col
                sm={12}
                md={12}
                lg={12}
                className="d-flex justify-content-end"
              >
                <h6 className="text-dark fw-bold">Client Name : {fullName}</h6>
              </Col>
            </Row>

            <Form>
              <Row>
                <Col lg={12} md={12} sm={12}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Due Collection Entry
                    </Card.Header>

                    <Card.Body className="fw-bold">
                      <Row>
                        <Col sm={12} md={6} lg={4} className="mb-3">
                          <Form.Group controlId="contractAmount">
                            <Form.Label>Contract Amount</Form.Label>
                            <Form.Control
                              disabled
                              type="number"
                              placeholder="Enter Contract Amount"
                              value={contractAmount}
                              onChange={(e) => {
                                setContractAmount(e.target.value * 1);
                                setDueAmount(
                                  e.target.value * 1 - paidAmount * 1
                                );
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col sm={12} md={6} lg={4} className="mb-3">
                          <Form.Group controlId="paidAmount">
                            <Form.Label>Pay Now</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Enter Paid Amount"
                              value={payNow}
                              onChange={(e) => setPayNow(e.target.value)}
                            />
                          </Form.Group>
                        </Col>

                        <Col sm={12} md={6} lg={4} className="mb-3">
                          <Form.Group controlId="dueAmount">
                            <Form.Label>Due Amount</Form.Label>
                            <Form.Control
                              disabled
                              type="number"
                              placeholder="Will Be Calculated Automatically!"
                              value={dueAmount}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        {/* <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Group controlId="paymentDate">
                          <Form.Label>Payment Date</Form.Label>
                          <Form.Control
                            disabled
                            type="date"
                            placeholder="Will Be Displayed Automatically!"
                            value={paymentDate}
                            onChange={(e) => setPaymentDate(e.target.value)}
                          />
                        </Form.Group>
                      </Col> */}

                        <Col sm={12} md={6} lg={4} className="mb-3">
                          <Form.Group controlId="paymentStatus">
                            <Form.Label>Payment Status</Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              placeholder="Will Be Displayed Automatically!"
                              value={paymentStatus}
                              onChange={(e) => setPaymentStatus(e.target.value)}
                            />
                          </Form.Group>
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                          <Form.Group controlId="agentName">
                            <Form.Label>Agent Name</Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              placeholder="No Agent Assigned!"
                              value={agentName}
                              onChange={(e) => setAgentName(e.target.value)}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      {paymentStatus === "Paid" ||
                      payNow === "" ||
                      payNow === 0 ||
                      payNow > dueAmount ? (
                        <>
                          <Row className="mt-3 mx-2">
                            <Button variant="outline-primary" disabled>
                              Add Due Record
                            </Button>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className="mt-3 mx-2">
                            <Button
                              variant="outline-primary"
                              onClick={handleAddDueRecord}
                            >
                              Add Due Record
                            </Button>
                          </Row>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>

            <Col className="mb-3 mt-2 d-flex justify-content-end">
              {/* <LinkContainer to='#'> */}
              <Button
                variant="outline-success"
                className="fw-bold"
                onClick={() => setPrintPreview(true)}
              >
                <TiPrinter className="mb-1" />
                &nbsp; Print List
              </Button>
              {/* </LinkContainer> */}
            </Col>

            <Card className="shadow" style={{ backgroundColor: "#74a2e3" }}>
              <Card.Header
                className="text-center text-black p-3 fw-bold"
                style={{ backgroundColor: "#74a2e3" }}
                as="h5"
              >
                Due Collection Records
              </Card.Header>

              <Table
                rounded
                bordered
                hover
                responsive
                style={{ maxHeight: "80vh" }}
              >
                <thead className="text-center">
                  <tr>
                    <th style={{ padding: "0px" }}>Contract Amount</th>
                    <th style={{ padding: "0px" }}>Paid Amount</th>
                    {/* <th>Due Amount</th> */}
                    <th style={{ padding: "0px" }}>Payment Date</th>
                  </tr>
                </thead>
                {dueCollections.length > 0 ? (
                  <>
                    {dueCollections.map((dueCollection) => (
                      <>
                        <tbody className="text-center">
                          <tr key={dueCollection._id}>
                            <td style={{ padding: "0px" }}>
                              {passport.contractAmount}
                            </td>
                            <td style={{ padding: "0px" }}>
                              {dueCollection.dueCollectionAmount}
                            </td>
                            {/* <td>{passport.contractAmount - passport.paidAmount}</td> */}
                            <td style={{ padding: "0px" }}>
                              {moment(dueCollection.createdAt).format(
                                "DD-MMMM-YYYY"
                              )}
                            </td>
                            {/* <td>
                            <Button
                              variant="danger"
                              onClick={() =>
                                handleDeleteDueRecord(dueCollection._id)
                              }
                            >
                              <MdDelete />
                            </Button>
                          </td> */}
                            {/* <td>{dueCollection.createdAt}</td> */}
                          </tr>
                        </tbody>
                      </>
                    ))}
                  </>
                ) : null}
              </Table>
            </Card>
          </>
        </Container>
      )}
    </>
  );
};

export default UpdateDueCollection1;
